(() => {
  window.__ALT_FILTER_VERSION = "2026-01-14_v12_slideshow_slide_counter";
  const DEBUG = false;
  const log = (...args) => DEBUG && console.log("[ALT-FILTER]", ...args);

  // ---------- Normalização ----------
  const normalize = (s) =>
    (s || "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim()
      .replace(/&/g, " e ")
      .replace(/[\s_]+/g, "-")
      .replace(/[^a-z0-9-]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");

  // ---------- CSS ----------
  const ensureStyle = () => {
    if (document.getElementById("alt-filter-style")) return;
    const style = document.createElement("style");
    style.id = "alt-filter-style";
    style.textContent = `
      .alt-filter-hidden { display:none !important; }
      html.alt-filter--pending slideshow-slide { opacity: 0 !important; }
    `;
    document.head.appendChild(style);
  };

  const setPending = (on) => {
    document.documentElement.classList.toggle("alt-filter--pending", !!on);
  };

  const showEl = (el) => el?.classList?.remove("alt-filter-hidden");
  const hideEl = (el) => el?.classList?.add("alt-filter-hidden");
  const isHidden = (el) => el?.classList?.contains("alt-filter-hidden");

  // ---------- Produto / variants ----------
  const getProductHandle = () => {
    const og = document.querySelector('meta[property="og:url"]')?.content;
    const url = og || window.location.href;
    const m = url.match(/\/products\/([^\/\?\#]+)/i);
    return m?.[1] || null;
  };

  const productCache = new Map();
  const fetchProduct = async () => {
    const handle = getProductHandle();
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);
    try {
      const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      productCache.set(handle, data);
      return data;
    } catch (e) {
      log("Falha ao buscar product.js", e);
      return null;
    }
  };

  const getVariantIdFromUrl = () => {
    try {
      const v = new URLSearchParams(window.location.search).get("variant");
      return v ? Number(v) : 0;
    } catch {
      return 0;
    }
  };

  const getVariantIdFromInput = () => {
    const el =
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('form.product-form input[name="id"]') ||
      document.querySelector('input[name="id"]');
    return el?.value ? Number(el.value) : 0;
  };

  const getCurrentVariantId = () => getVariantIdFromUrl() || getVariantIdFromInput() || 0;

  const inferColorIndex = (product) => {
    const names = (product?.options || []).map(String);
    const idx = names.findIndex((n) => /(cor|color|colour)/i.test(n.trim()));
    return idx >= 0 ? idx : 0;
  };

  const getVariantOption = (variant, idx0) => {
    const key = `option${idx0 + 1}`;
    return variant?.[key] || "";
  };

  // ---------- Slideshow alvo (hero do produto) ----------
  const getHeroSlideshowRoot = () => {
    // Heurística segura: pega o primeiro slideshow que contém .product-media (sua imagem tem class="product-media__image")
    const img = document.querySelector(".product-media__image");
    const root = img?.closest("slideshow-component, .product, main") || document.querySelector("main") || document.body;

    // Dentro disso, pega o slideshow-container mais próximo
    const container =
      img?.closest("slideshow-container") ||
      root.querySelector("slideshow-container") ||
      document.querySelector("slideshow-container");

    return container || null;
  };

  const getSlides = () => {
    const root = getHeroSlideshowRoot();
    if (!root) return [];
    return [...root.querySelectorAll("slideshow-slide")];
  };

  const getActiveSlide = () => {
    const slides = getSlides();
    const active = slides.find((s) => s.getAttribute("aria-hidden") === "false") || null;
    return { slides, active };
  };

  const getAltKeyFromSlide = (slide) => {
    const img = slide.querySelector("img[alt]");
    return normalize(img?.getAttribute("alt") || "");
  };

  // ---------- Contador ----------
  const ensureTotalSpan = () => {
    const root = getHeroSlideshowRoot();
    if (!root) return null;

    const counter = root.querySelector(".slideshow-controls__counter");
    if (!counter) return null;

    const currentEl = counter.querySelector('span[ref="current"]');
    const slashEl = counter.querySelector(".slash");

    if (!currentEl || !slashEl) return null;

    let totalEl = counter.querySelector('span[data-altfilter="total"]');
    if (totalEl) return { counter, currentEl, totalEl };

    // total hoje é texto após "/". Vamos substituir por <span data-altfilter="total">X</span>
    totalEl = document.createElement("span");
    totalEl.setAttribute("data-altfilter", "total");
    totalEl.textContent = "0";

    // Remove nós após a slash (texto "9", espaços etc.) e injeta o span
    let n = slashEl.nextSibling;
    while (n) {
      const next = n.nextSibling;
      counter.removeChild(n);
      n = next;
    }
    counter.appendChild(totalEl);

    return { counter, currentEl, totalEl };
  };

  const updateCounter = () => {
    const info = ensureTotalSpan();
    if (!info) return;

    const { currentEl, totalEl } = info;
    const { slides, active } = getActiveSlide();

    const visibleSlides = slides.filter((s) => !isHidden(s));
    const total = visibleSlides.length || 0;

    let current = 0;
    if (active && !isHidden(active)) {
      current = visibleSlides.indexOf(active) + 1;
    } else if (visibleSlides.length) {
      // se o ativo estiver oculto, assume o primeiro visível
      current = 1;
    }

    currentEl.textContent = String(Math.max(0, current));
    totalEl.textContent = String(total);
  };

  // ---------- Filtro ----------
  let runToken = 0;
  let lastVariantId = 0;
  let timer = null;

  const scheduleApply = (ms = 60) => {
    clearTimeout(timer);
    timer = setTimeout(applyFilter, ms);
  };

  const applyFilter = async () => {
    ensureStyle();
    const myToken = ++runToken;

    const variantId = getCurrentVariantId();
    if (!variantId) {
      setPending(false);
      return;
    }

    setPending(true);

    const product = await fetchProduct();
    if (!product || myToken !== runToken) {
      setPending(false);
      return;
    }

    const colorIndex = inferColorIndex(product);
    const selectedVariant = (product.variants || []).find((v) => Number(v.id) === Number(variantId));
    if (!selectedVariant) {
      setPending(false);
      return;
    }

    const selectedColorRaw =
      getVariantOption(selectedVariant, colorIndex) || getVariantOption(selectedVariant, 0);
    const selectedKey = normalize(selectedColorRaw);

    const allColorsRaw = [
      ...new Set((product.variants || []).map((v) => getVariantOption(v, colorIndex)).filter(Boolean)),
    ];
    const allColorKeys = allColorsRaw.map(normalize).filter(Boolean);

    const slides = getSlides();
    if (!slides.length || !selectedKey || !allColorKeys.length) {
      setPending(false);
      updateCounter();
      return;
    }

    const targets = slides
      .map((s) => ({ el: s, altKey: getAltKeyFromSlide(s) }))
      .filter((t) => t.altKey);

    const isSpecific = (altKey) => allColorKeys.some((c) => altKey.includes(c));
    const hasMatch = targets.some((t) => isSpecific(t.altKey) && t.altKey.includes(selectedKey));

    // Mostra tudo antes (ainda em pending)
    slides.forEach(showEl);

    // Se não existe nenhuma imagem “específica” para a cor, não filtra (mostra tudo)
    if (!hasMatch) {
      setPending(false);
      updateCounter();
      return;
    }

    // Regra: genéricas (sem cor do produto no alt) aparecem em todas
    slides.forEach((s) => {
      const altKey = getAltKeyFromSlide(s);
      if (!altKey) return showEl(s);

      const show = !isSpecific(altKey) || altKey.includes(selectedKey);
      show ? showEl(s) : hideEl(s);
    });

    // Se o slide ativo ficou oculto, tenta “pular” para o primeiro visível (sem depender de API)
    const { active } = getActiveSlide();
    if (active && isHidden(active)) {
      const firstVisible = slides.find((s) => !isHidden(s));
      // Aqui não forçamos scroll/track porque o componente controla.
      // Mas o contador e as setas vão se manter corretos com o skip.
      if (firstVisible) {
        // nada a fazer aqui além de atualizar contador
      }
    }

    setPending(false);
    updateCounter();
  };

  // ---------- Setas: pular ocultos (sem obrigar passar pelos inválidos) ----------
const ARROW_BYPASS = "__altFilterBypass";

const getArrowButtons = () => {
  const root = getHeroSlideshowRoot();
  if (!root) return { prev: null, next: null };
  return {
    prev: root.querySelector("button.slideshow-control-previous"),
    next: root.querySelector("button.slideshow-control-next"),
  };
};

const nativeArrowClick = (btn) => {
  // Bypass para não cair no nosso próprio handler
  btn[ARROW_BYPASS] = true;
  btn.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
  btn[ARROW_BYPASS] = false;
};

const stepUntilVisible = async (btn, maxSteps = 12) => {
  if (!btn) return;

  const wait = (ms) => new Promise((r) => setTimeout(r, ms));

  // Importante: comparar pelo ID/posição do slide ativo, não só referência
  const getActiveIdentity = () => {
    const { active } = getActiveSlide();
    if (!active) return "";
    // tenta um identificador estável
    return (
      active.getAttribute("data-media-id") ||
      active.getAttribute("id") ||
      active.getAttribute("ref") ||
      String(active.outerHTML.length) // fallback leve
    );
  };

  let beforeId = getActiveIdentity();

  for (let i = 0; i < maxSteps; i++) {
    nativeArrowClick(btn);

    // dá tempo do slideshow atualizar aria-hidden
    await wait(80);

    const { active } = getActiveSlide();
    if (!active) continue;

    const nowId = getActiveIdentity();

    // se caiu num slide visível, terminou
    if (!isHidden(active)) {
      updateCounter();
      return;
    }

    // se mudou para um oculto, continua pulando
    // se nem mudou (alguns sliders travam), também continua tentando
    beforeId = nowId;
  }

  updateCounter();
};

const hookArrowSkip = () => {
  const { prev, next } = getArrowButtons();
  if (!prev && !next) return;

  const bind = (btn) => {
    if (!btn || btn.__altFilterBound) return;
    btn.__altFilterBound = true;

    btn.addEventListener(
      "click",
      (e) => {
        // Se é clique programático (do nosso skip), deixa o tema processar
        if (btn[ARROW_BYPASS]) return;

        // Se não há nenhum slide oculto, deixa nativo e só atualiza contador
        const slides = getSlides();
        const hasHidden = slides.some(isHidden);
        if (!hasHidden) {
          setTimeout(updateCounter, 0);
          return;
        }

        // Intercepta o clique do usuário e faz o skip completo em 1 ação
        e.preventDefault();
        e.stopPropagation();

        stepUntilVisible(btn);
      },
      true // capture para ganhar do handler do tema
    );
  };

  bind(prev);
  bind(next);
};


  // ---------- Observers / boot ----------
  const hookVariantChanges = () => {
    // input[name=id]
    const idInput =
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('form.product-form input[name="id"]') ||
      document.querySelector('input[name="id"]');

    if (idInput && !idInput.__altFilterObserved) {
      idInput.__altFilterObserved = true;
      new MutationObserver(() => scheduleApply(40)).observe(idInput, {
        attributes: true,
        attributeFilter: ["value"],
      });
    }

    // URL changes via history
    if (!window.__altFilterHistoryHooked) {
      window.__altFilterHistoryHooked = true;

      const _push = history.pushState;
      const _replace = history.replaceState;

      const onNav = () => {
        const vid = getCurrentVariantId();
        if (vid && vid !== lastVariantId) {
          lastVariantId = vid;
          setPending(true);
          scheduleApply(20);
        }
      };

      history.pushState = function () {
        _push.apply(this, arguments);
        onNav();
      };
      history.replaceState = function () {
        _replace.apply(this, arguments);
        onNav();
      };
      window.addEventListener("popstate", onNav);
    }
  };

  const hookActiveSlideObserver = () => {
    const root = getHeroSlideshowRoot();
    if (!root || root.__altFilterActiveObs) return;
    root.__altFilterActiveObs = true;

    // Quando aria-hidden muda (slide ativo troca), atualiza contador
    new MutationObserver(() => {
      updateCounter();
    }).observe(root, { attributes: true, subtree: true, attributeFilter: ["aria-hidden"] });
  };

  const boot = () => {
    ensureStyle();

    lastVariantId = getCurrentVariantId();
    if (lastVariantId) setPending(true);

    hookVariantChanges();
    hookArrowSkip();
    hookActiveSlideObserver();

    scheduleApply(0);

    // Se a galeria re-renderizar, reaplica e reatacha
    const main = document.querySelector("main") || document.body;
    if (!main.__altFilterRerenderObs) {
      main.__altFilterRerenderObs = true;
      new MutationObserver(() => {
        hookArrowSkip();
        hookActiveSlideObserver();
        scheduleApply(90);
      }).observe(main, { childList: true, subtree: true });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
